import { useMemo } from 'react'
import { pluralize } from '../../../utility/helperFunctions'

export function useProgramsText({ selectedPrograms = [], selectedSeries = [], selectedUsers = [], selectedCoaches = [] }) {
  return useMemo(() => {
    const totalRecipients =
      selectedPrograms.reduce((acc, p) => acc + (p.students?.length || 0), 0) +
      selectedSeries.reduce((acc, s) => acc + (s.students?.length || 0), 0) +
      (selectedUsers.length || 0) +
      (selectedCoaches.length || 0)

    if ((selectedPrograms.length > 0 || selectedSeries.length > 0) && selectedUsers.length === 0 && selectedCoaches.length === 0) {
      const names = [...selectedPrograms.map(p => p.name), ...selectedSeries.map(s => s.title)]
      if (names.length === 1) {
        return `Posted to ${names[0]}`
      } else {
        return `Posted to ${names[0]}... + ${names.length - 1} ${pluralize('other', names.length - 1)}`
      }
    }

    if (totalRecipients > 0) {
      return `Posted to ${totalRecipients} ${pluralize('Member', totalRecipients)}`
    }

    return 'Add Members'
  }, [selectedPrograms, selectedSeries, selectedUsers, selectedCoaches])
}
